import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
// import { ORQ } from 'src/app/models/exercise.model';
import { ScrollToService, ScrollToConfigOptions } from '@nicky-lenaers/ngx-scroll-to';
import { ORQ } from 'src/app/shared/models/exercise.model';

@Component({
  selector: 'app-orq',
  templateUrl: './orq.component.html',
  styleUrls: ['./orq.component.css']
})
export class OrqComponent {
  words: number = 1;
  _element: ORQ;
  _answer: string

  @Input() set answer(answer) {
    if (answer) {
      this._answer = answer;
      this.questionChecked = true;
    }
  }
  @Input() id: string
  @Output() onFocusOut = new EventEmitter<Object>();
  @Output() onReview = new EventEmitter<Object>();
  @Output() back = new EventEmitter<Boolean>(false);
  @Input() isResultPublished: boolean = false;
  @Input() taFeedback: any;
  @Input() points: any;
  @Input() variableFeedback: any;
  @Input() userFeedback;
  @Output() reportFeedback = new EventEmitter<Object>();
  @Output() likeDislike = new EventEmitter<boolean>();
  @Input() isSubmitted: boolean = false;
  @Input() showBackButton: boolean = false;
  @Input() immediateFeedBackRequired: boolean = false;
  @Input() fixedEditor: any;
 

  
  questionChecked: boolean = false;
  @Input() set element(element) {
    this._element = element
  }
  @Input() index: any;
  @Input() exerciseTimetrackingdata;
  @Input() questionBlos;
  constructor(private _scrollToService: ScrollToService) { }
  next() {
    this.onFocusOut.emit({ elementId: this.id, answer: this._answer });
  }
  onInput(value) {
    this.words = value.match(/\S+/g).length;
    if (this.words > this._element.wordLimit) {
      let trimmed = this._answer.split(/\s+/, this._element.wordLimit).join(" ");
      this._answer = trimmed + " ";
    }
  }
  backHandler() {
    this.back.emit(true);
  }
  check() {
    this.questionChecked = true;
    this.onReview.emit({ elementId: this.id, answer: this._answer });
  }
  skip() {
    this.onFocusOut.emit({ elementId: this.id, answer: '' });
  }
  _reportFeedback() {
    this.reportFeedback.emit(this._element);
  }

  _likeDislike(like) {
    this.likeDislike.emit(like);
  }

  setValue(value) {
    this._answer = value;
  }
}

